/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { CommandResource } from '@alfa-client/command-shared';
import { Component, input, InputSignal } from '@angular/core';
import { CollapsibleSectionComponent } from '@ods/system';
import { HistorieItemHeaderComponent } from '../historie-item-header/historie-item-header.component';

@Component({
  selector: 'alfa-expansion-panel-with-user',
  templateUrl: './expansion-panel-with-user.component.html',
  imports: [CollapsibleSectionComponent, HistorieItemHeaderComponent],
})
export class ExpansionPanelWithUserComponent {
  public readonly headline: InputSignal<string | undefined> = input<string>();
  public readonly expanded: InputSignal<boolean> = input<boolean>(false);
  public readonly resource: InputSignal<CommandResource> = input.required<CommandResource>();
}
